export const STORAGE_KEYS = {
  AUTH: 'michidart_auth',
  CART: 'michidart_cart',
};
